import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { ROUTE_PATHS } from '@/config/constants';
import { getSliceStatus } from '@/pages/MerchandisingCollections/utils/getSliceStatus';
import { MerchandisingCollectionSlice } from '@/services/MerchandisingCollectionsService';

interface HeaderProps {
  slice: Pick<
    MerchandisingCollectionSlice,
    'collectionId' | 'name' | 'startsAt' | 'endsAt'
  >;
}

export function Header({ slice }: HeaderProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.MerchandisingCollections.pages.Slice.components.Header',
  });

  const sliceStatus = getSliceStatus(slice);

  return (
    <div className="flex items-center space-x-4">
      <Link
        to={ROUTE_PATHS.MERCHANDISING_COLLECTION.replace(
          ':collectionId',
          String(slice.collectionId),
        )}
      >
        <Button variant="outline" size="sm">
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t('backButtonLabel')}
        </Button>
      </Link>

      <div className="flex-1">
        <h1 className="text-3xl font-bold tracking-tight">
          {slice.name}{' '}
          <span
            className="text-sm font-normal"
            style={{ color: sliceStatus.color }}
          >
            {sliceStatus.text}
          </span>
        </h1>
      </div>
    </div>
  );
}
